import { createAction } from 'redux-actions'
import * as constants from './constants'

export const startConversationsRevealTrial = createAction(constants.START_CONVERSATIONS_REVEAL_TRIAL)
export const startConversationsRevealTrialPending = createAction(constants.START_CONVERSATIONS_REVEAL_TRIAL_PENDING)
export const startConversationsRevealTrialSuccess = createAction(constants.START_CONVERSATIONS_REVEAL_TRIAL_SUCCESS)
export const startConversationsRevealTrialFailed = createAction(constants.START_CONVERSATIONS_REVEAL_TRIAL_FAILED)

export const startDriftIntelRevealTrial = createAction(constants.START_DRIFT_INTEL_REVEAL_TRIAL)
export const startDriftIntelRevealTrialPending = createAction(constants.START_DRIFT_INTEL_REVEAL_TRIAL_PENDING)
export const startDriftIntelRevealTrialSuccess = createAction(constants.START_DRIFT_INTEL_REVEAL_TRIAL_SUCCESS)
export const startDriftIntelRevealTrialFailed = createAction(constants.START_DRIFT_INTEL_REVEAL_TRIAL_FAILED)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/gates/actions.js